import { render, staticRenderFns } from "./ModalNextFollowup.vue?vue&type=template&id=cbe73028&"
import script from "./ModalNextFollowup.vue?vue&type=script&lang=js&"
export * from "./ModalNextFollowup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports